import { Background, BackgroundResponsive, BackgroundHalf } from './Background';

Background.Responsive = BackgroundResponsive;
Background.Half = BackgroundHalf;

export { Background };
